/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsrefundtitle2Inputs */

const en_ticketsrefundtitle2 = /** @type {(inputs: Ticketsrefundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund this order?`)
};

const de_ticketsrefundtitle2 = /** @type {(inputs: Ticketsrefundtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellung erstatten?`)
};

/**
* | output |
* | --- |
* | "Refund this order?" |
*
* @param {Ticketsrefundtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsrefundtitle2 = /** @type {((inputs?: Ticketsrefundtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsrefundtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsrefundtitle2(inputs)
	return de_ticketsrefundtitle2(inputs)
});
export { ticketsrefundtitle2 as "ticketsRefundTitle" }